import React, { useEffect, useState } from "react";

const UseAppendScript = (scriptId = "", removeContainer = false) => {
  return (payloadScript) => {
    const script = document.createElement("script");
    script.id = scriptId ? scriptId : "fb-pixel-script";
    const scriptText = document.createTextNode(payloadScript);

    script.appendChild(scriptText);
    document.head.appendChild(script);
  };
};

export default UseAppendScript;
